import { Component, Input } from '@angular/core';
import { CoverageLegend } from './models/coverage-legend.model';

@Component({
    selector: 'coverage-legend-item',
    template: require('./coverage-legend-item.component.html')
})
export class CoverageLegendItemComponent {
    @Input() public legendInfo: CoverageLegend;

    constructor() { }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/coverage-modal/coverage-legend-item.component.ts